module.exports = __webpack_public_path__ + "media/images/icon-line-s-2b9d465468e39492980f93f55e3ff410.svg";